import { navigate } from "@reach/router";
import React, { useContext, useEffect } from "react";
import LoginForm from "../components/auth/LoginForm";
import { UserContext } from "../context/UserContext";

const Login = () => {
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (user !== null && !window.location.href.includes("mylatina")) {
      navigate("/mylatina");
    }
  }, [user]);

  return (
    <div className="container-fluid">
      <div
        className="row position-absolute w-100 bg-vertical vh-100"
        style={{ zIndex: 0 }}
      ></div>
      <div
        className="row position-absolute w-100 bg-dark vh-100"
        style={{ opacity: 0.6, zIndex: 1 }}
      ></div>
      <div className="row align-items-center vh-100">
        <div className="container-fluid">
          <LoginForm theme="dark" />
        </div>
      </div>
    </div>
  );
};

export default Login;
